import dayjs from 'dayjs';

import { INVALID_DATE_DAY_JS } from './stringHelper';

export const getFormattedDateRange = (
  dates: string[],
  isUk = false
): string => {
  return dates
    ?.map((date) => {
      if (isUk) {
        const formattedDate = dayjs(date).format('D/M');
        return formattedDate === INVALID_DATE_DAY_JS ? date : formattedDate;
      }
      const [_, month, day] = date.split('-');
      return `${parseInt(month)}/${parseInt(day)}`;
    })
    .join(', ');
};

// Sorts "YYYY-MM-DD" dates so the latest date comes first
export const sortDatesLatestFirst = (dates: string[]): string[] =>
  [...(dates ?? [])].sort((a, b) => b.localeCompare(a));

export const getUnitToDatesMap = (
  bookingDatesObj: BookingDatesObj
): { [unit: string]: string[] } =>
  Object.keys(bookingDatesObj).reduce((acc, curr) => {
    bookingDatesObj[curr].forEach((bookingDate) => {
      if (curr in acc) {
        acc[curr].push(bookingDate.booking_date);
      } else {
        acc[curr] = [bookingDate.booking_date];
      }
    });
    return acc;
  }, {});

export const convertDateFormat = (inputDate: string): string => {
  const dateParts = inputDate.split('-');
  const convertedDate = `${dateParts[1]}/${dateParts[2]}/${dateParts[0].slice(
    2
  )}`;
  return convertedDate;
};

export const getFormattedDates = (
  dates: string[],
  userSelectedCountry: ProductionCountry
): string[] =>
  dates
    ? dates
        .map((date) => date.replace(/\//g, '-')) // Ensure consistent "YYYY-MM-DD" format
        .sort((a, b) => new Date(a).getTime() - new Date(b).getTime()) // New sorting logic with Date objects
        .map((date, i) => {
          const [_, month, day] = date.split('-');
          const formattedDateString =
            userSelectedCountry === 'UK'
              ? `${day}/${month}`
              : `${month}/${day}`;
          return i === 0 ? formattedDateString : `, ${formattedDateString}`;
        })
    : [];

export const formatPrice = (price?: string): string => {
  const validInput = typeof price === 'string' && price.length > 0;
  if (!validInput) return '';
  const hasDollarSign = price.startsWith('$');
  const value = hasDollarSign ? price.slice(1) : price;
  const [numericValue, ...rest] = value.split('/');

  const formattedValue =
    Number(numericValue) % 1 ? Number(numericValue).toFixed(2) : numericValue;
  return `${hasDollarSign ? '$' : ''}${formattedValue}${
    rest.length ? '/' : ''
  }${rest}`;
};
